export const NUMBER_REQUESTS_PATH = "/number-requests";
export const NUMBER_REQUESTS_DETAIL_VIEW_PATH = `${NUMBER_REQUESTS_PATH}/:numberRequestUuid`;
